<div class="app-body">
  <main class="main d-flex align-items-center">
    <div class="container" style="margin-top: 5%">
      <div class="text-center">
        <img src="assets/img/brand/sygnet.png" alt="LC+" style="margin: 30px auto; width: 320px" />
        <h5 style="margin-bottom: 20px" *ngIf="msg">{{ msg }}</h5>
      </div>
      <div class="row">
        <div class="col-md-6 offset-md-3">
          <div class="card-group">
            <div class="card">
              <div class="card-body">
                <a href="{{ urls.android }}" class="btn btn-lg btn-outline-dark btn-block btn-square"
                  ><i class="fa fa-android"></i> Android</a
                >
                <br />
                <a href="{{ urls.ios }}" class="btn btn-lg btn-outline-dark btn-block btn-square"
                  ><i class="fa fa-apple"></i> iOS</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
